import type { JSX } from 'react';

import { toPersianDigits } from '@bookora/shared';
import { NumericRange } from '@bookora/ui';

import { clockLabel } from './clock';

/**
 * A shift's wall-clock range, «۰۹:۰۰–۱۷:۰۰». See `clock.ts` for why this is
 * not the kit's `TimeRange`.
 */
export interface ClockRangeProps {
  /** Minutes from midnight, or an `HH:mm` string as the API's `start`/`end` carry it. */
  start: number | string;
  end: number | string;
  className?: string;
}

function asLabel(value: number | string): string {
  return typeof value === 'number' ? clockLabel(value) : toPersianDigits(value);
}

/** «۰۹:۰۰–۱۷:۰۰», isolated so the two ends never swap. */
export function ClockRange({ start, end, className }: ClockRangeProps): JSX.Element {
  return <NumericRange from={asLabel(start)} to={asLabel(end)} className={className} />;
}
